// Imports
// ------
import { observable } from 'mobx';

// Exports
export const tickerSize = observable({
    height: null
});
